import { RootState } from '../reducers'

export const isLoadingSelector = (state: RootState, loaderName: string) => (state.loading[loaderName] && state.loading[loaderName].isLoading) || false

export const loadingStatusSelector = (state: RootState, loaderName: string) => state.loading[loaderName]
